export let PrivacyRequest;
(function (_PrivacyRequest) {
  let Type = /*#__PURE__*/function (Type) {
    Type["DELETE"] = "delete";
    Type["EXPORT"] = "export";
    Type["CORRECT"] = "correct";
    Type["OTHER"] = "other";
    return Type;
  }({});
  _PrivacyRequest.Type = Type;
  let Status = /*#__PURE__*/function (Status) {
    Status["UNCONFIRMED"] = "unconfirmed";
    Status["CONFIRMED"] = "confirmed";
    return Status;
  }({});
  _PrivacyRequest.Status = Status;
})(PrivacyRequest || (PrivacyRequest = {}));